/**
 * @generated SignedSource<<ec079cce1e9b9d06e85d18b627ced680>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type approverSelector_softwareReleasesApprovers$data = {
  readonly __id: string;
  readonly id: string;
  readonly " $fragmentType": "approverSelector_softwareReleasesApprovers";
};
export type approverSelector_softwareReleasesApprovers$key = {
  readonly " $data"?: approverSelector_softwareReleasesApprovers$data;
  readonly " $fragmentSpreads": FragmentRefs<"approverSelector_softwareReleasesApprovers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "approverSelector_softwareReleasesApprovers",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "eb08f554f17d908a61adf9079c7b4066";

export default node;
